import React, { useEffect } from "react";
import { useState } from "react";
import { useDebounce } from "./MicroComponents";
import { Search } from "../../assets/svg";

const DebounceSearch = ({
  search,
  handleChange,
  add2Chardelay = true,
  placeholder,
  className = "",
}) => {
  const [searchLocal, setSearchLocal] = useState("");
  const debounceSearch = useDebounce(searchLocal);

  const handleSearch = (e) => {
    const value = e?.target?.value || "";
    setSearchLocal(value);
  };

  useEffect(() => {
    if (
      (add2Chardelay &&
        (debounceSearch?.length === 0 || debounceSearch?.length > 1)) ||
      !add2Chardelay
    ) {
      handleChange(debounceSearch || "");
    }
  }, [debounceSearch]);

  useEffect(() => {
    setSearchLocal(search);
  }, [search]);

  return (
    <>
      <div
        className={`relative w-full ${
          className || "max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg"
        }`}
      >
        <Search className="absolute top-1/2 -translate-y-1/2 translate-x-3 text-gray-500" />
        <input
          type="search"
          onChange={handleSearch}
          value={searchLocal}
          className="w-full sm:py-1 py-1.5 pr-4 pl-10 bg-white border rounded border-borderTheme/80 focus:border-themeBtn text-sm sm:text-base md:text-lg"
          placeholder={placeholder}
        />
      </div>
    </>
  );
};

export default DebounceSearch;
